import { render, staticRenderFns } from "./AdminTeacherDataAnalysis.vue?vue&type=template&id=beb446fa&scoped=true&"
import script from "./AdminTeacherDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./AdminTeacherDataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AdminTeacherDataAnalysis.vue?vue&type=style&index=0&id=beb446fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb446fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VRow})
